import React from "react";
import header from "../../assets/exchange-img.png";
import "./Exchange.css";

const Exchange = () => {
  return (
    <div className="exchange-container">
      <div className="exchange-content">
        <h1 className="exchange-title">Exchange & Transact Easily</h1>
        <p className="exchange-description">
          You can trade your crypto anytime, anywhere within TokenPocket.
        </p>
        <p className="exchange-description">
          Buy crypto with credit cards. Store, send, cross chain and exchange
          with ease.
        </p>

        <div className="exchange-buttons">
          <div>
            <h4>Bridge</h4>
            <p>Among different chains</p>
          </div>
          <div>
            <h4>TP Card</h4>
            <p>Pay with Crypto</p>
          </div>
          <div>
            <h4>Buy Crypto</h4>
            <p>In 5 minutes</p>
          </div>
        </div>
      </div>
      <div className="exchange-images">
        <img src={header} alt="security" />
      </div>
    </div>
  );
};

export default Exchange;
